export default "__VITE_ASSET__EM$PgeZc__"